var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-ish',_vm._l((_vm.properties),function(property){return _c('table-ish-row-router-link',{key:property.uuid,attrs:{"to":{
            name: _vm.$router.fix('dashboard.*.properties.show'),
            params: {
                property: property.uuid
            }
        }}},[_c('table-ish-cell',[_c('truncate-hack',[_vm._v("\n                "+_vm._s(property.name)+"\n            ")]),_vm._v(" "),(property.address.street !== property.name)?_c('truncate-hack',{attrs:{"slot":"secondary"},slot:"secondary"},[_vm._v("\n                "+_vm._s(property.address.street)+"\n            ")]):_vm._e()],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }